import React, { useEffect } from "react";
import TopNavBar from "./components/TopNavBar";
import Sidebar from "./components/SideNavBar";
import BottomMobileNav from "./components/BottomMobileNav";
import LoginScreen from "./screens/LoginScreen";
import PrivateRoute from "./routing/privateRoute";
import { RoleBasedRoute } from "./routing/privateRoute";
import ProfileScreen from "./screens/ProfileScreen";

import { Col, Row } from "react-bootstrap";
import { Route, BrowserRouter as Router, } from "react-router-dom";
import Billing from "./screens/Billing";
import DailyBook from "./screens/DailyBook";
import Tests from "./screens/Tests";
import Report from "./screens/Reports";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../src/actions/userActions";
import axios from "axios";
import Bookings from "./screens/Bookings";
import Booking from "./screens/Booking";
import ManageUsers from "./screens/ManageUsers";
import ManageLabs from "./screens/ManageLabs";
import ScrollToTop from "./components/ScrollToTop";

const App = () => {
  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin
  const dispatch = useDispatch();

  // ── Version check: fetch /version.json once on mount, hard refresh on mismatch ──
  useEffect(() => {
    fetch(`/version.json?t=${Date.now()}`)   // ?t= prevents browser caching
      .then((res) => res.json())
      .then(({ version: serverVersion }) => {
        const storedVersion = localStorage.getItem('app-version');
        if (!storedVersion) {
          // First visit — just store it
          localStorage.setItem('app-version', serverVersion);
          return;
        }
        if (storedVersion !== serverVersion) {
          console.log(`[App] Version mismatch (${storedVersion} → ${serverVersion}). Hard refreshing...`);
          sessionStorage.clear();
          localStorage.clear();
          if ("caches" in window) {
            caches.keys().then((keys) => Promise.all(keys.map((key) => caches.delete(key))));
          }
          if ("serviceWorker" in navigator) {
            navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister()));
          }
          localStorage.setItem('app-version', serverVersion);
          window.location.reload(true);
        }
      })
      .catch(() => { /* version.json missing — silently skip */ });
  }, []); // runs only once on app mount

  // ── Token validation: verify JWT is still valid on each page load ──
  useEffect(() => {
    if (window.location.pathname !== '/login') {
      try {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userInfo?.token}`,
          },
        };
        axios.get(`/api/v1/users/validToken`, config).catch(() => dispatch(logout()));
      } catch (error) {
        dispatch(logout());
      }
    }
  }, [dispatch, userInfo?.token]);

  return (
    <Router>
      <ScrollToTop />
      <TopNavBar />
      <Row className="m-0 w-100" style={{ minHeight: "100vh" }}>
        <>
          <Sidebar />
        </>
        <Col md={10} className="custom-page mx-auto">
          <Route path="/login" component={LoginScreen} />

          {/* private routes — accessible to all authenticated users */}
          <PrivateRoute path="/" exact component={Billing} />
          <PrivateRoute path="/profile" exact component={ProfileScreen} />

          <PrivateRoute path="/billing" exact component={Billing} />
          <PrivateRoute path="/daily-book" exact component={DailyBook} />
          <PrivateRoute path="/reports" exact component={Report} />
          <PrivateRoute path="/booking" exact component={Booking} />
          <PrivateRoute path="/bookings" exact component={Bookings} />

          {/* role-based routes — lab & admin only */}
          <RoleBasedRoute path="/tests" exact roles={['lab', 'admin']} component={Tests} />
          <RoleBasedRoute path="/manage-users" exact roles={['lab', 'admin']} component={ManageUsers} />

          {/* admin only */}
          <RoleBasedRoute path="/manage-labs" exact roles={['admin']} component={ManageLabs} />
        </Col>
      </Row>
      <BottomMobileNav />
    </Router>
  );
};

export default App;
